module.exports = __webpack_public_path__ + "img/full4-min.5a91c516.png";